import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import classNames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { useUsersStore } from 'services/users';
import { useParams } from 'react-router-dom';

export default function MonitoringPhaseCard({ data, status = 'inProgress', reports = [] }: any) {
	const { t } = useTranslation();
	const isCompleted = moment(data?.end_date).isBefore(moment());
	const { navigateWithLanguage } = useLanguageNavigate();
	const { user } = useUsersStore();
	const { id: monitoringId } = useParams(); // Get the current monitoring ID from URL
	
	// Find report for this phase if it exists
	const report = reports?.find((r: any) => r.phases_id === data.phases_id);
	
	const handleReportClick = (e: React.MouseEvent, reportLink: string) => {
		e.stopPropagation(); // Prevent card click event
		window.open(reportLink, '_blank');
	};

	const handleCardClick = () => {
		const userRole = user?.role?.toLowerCase() || 'farmer';
		
		// Store the current monitoring ID in localStorage to be used for API calls
		const currentMonitoringId = monitoringId || '';
		
		// Store the phase ID in localStorage for API calls
		localStorage.setItem('phase_id', data.phases_id);
		
		// Navigate to topics page for this phase
		navigateWithLanguage(`/${userRole}/monitoring/project/${data.phases_id}/topics`);
		
		// Store selected offer in localStorage for the topics page to use
		// Make sure to include both the phases_id and the monitoring_id (as id)
		localStorage.setItem('selectedOffer', JSON.stringify({
			...data,
			phases_id: data.phases_id,
			id: currentMonitoringId, // This is crucial - the monitoring/request ID
			monitoring_id: currentMonitoringId // Backup in case some code uses this field
		}));
	};

	return (
		<div
			className={classNames(
				'cursor-pointer max-xsm:flex-col lg:max-w-[420px] flex flex-row justify-between items-start px-5 py-3 border-[2px]  rounded-xl bg-white shadow-lg',
				{
					'border-primary': isCompleted,
					'border-secondary': !isCompleted,
				}
			)}
			onClick={handleCardClick}
		>
			<div className="flex flex-col gap-1 mr-1">
				<div className="flex-row gap-2 items-center">
					<span className="font-bold text-dark text-base mr-1">{t('phase')}:</span>
					<span className="font-normal text-dark text-base">{data.phases_name}</span>
				</div>
			</div>

			<div className="flex flex-row gap-4 items-center justify-center">
				{report ? (
					<div className="text-primary flex items-center justify-center gap-2">
						<span 
							className="font-semibold text-base text-primary underline cursor-pointer" 
							onClick={(e) => handleReportClick(e, report.report_link)}
						>
							F-100
						</span>
						<CheckCircleOutlineOutlinedIcon />
					</div>
				) : (
					<div className="text-secondary gap-2 flex items-center justify-center border border-secondary rounded-lg px-2">
						<AccessTimeIcon />
						<span className="font-semibold text-base text-secondary">{t(status)}</span>
					</div>
				)}
			</div>
		</div>
	);
}
